import Image from "next/image";
import Link from "next/link";
import Typography, { Title } from "../../../components/Typography";
import { useWindowDimensions } from "../../../hooks";
import Gallery from "./Gallery";
import { Container, Content, TextLink } from "./styled";

export default function ProductCategoryContent({
  title,
  content,
  background,
  gallery,
  minHeight,
}) {
  const { isSmallDevice } = useWindowDimensions();
  return (
    <section>
      <Container background={background}>
        <Content minHeight={minHeight}>
          <Title>{title}</Title>
          {content.map((content) => {
            if (content.type === "text") {
              return content.items.map((item) => (
                <Typography key={item.id}>{item.text}</Typography>
              ));
            }
            if (content.type === "link") {
              return content.items.map((item, idx) => (
                <Link href={item.href} key={item.id} passHref>
                  <TextLink
                    margin={
                      idx === content.items.length - 1 ? [0, 0, 16, 0] : [0]
                    }
                  >
                    {item.text}
                  </TextLink>
                </Link>
              ));
            }
          })}
        </Content>
      </Container>
      {isSmallDevice && <Image {...background} layout="responsive" />}
      <Gallery images={gallery} />
    </section>
  );
}
